import type { FaireProductEntity } from "../../entity_types/product";

export const p_jgfrdcndc6: FaireProductEntity = {
  token: "p_jgfrdcndc6",
  type: "product",
  name: "Single Shower Steamer - Aromatherapy - Wholesale Spa Tablets",
  brandToken: "b_mynq63kmmf",
  brandName: "Relax Away Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/1ebd4e0810efa9230e191ed06453d93f8094409b198d771d1afe19614df04083.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e63eb8f485a70b3c81e89743a05404aa0c4585513f58b7deeb7b061197cad5e.png",
    "https://cdn.faire.com/fastly/d5e46b3ea948b4a1b87352d59b8cdbf6085ff423f0f87a346bd026926571c2bf.png",
    "https://cdn.faire.com/fastly/f29fd57104746513ccbf4e0c2df47eeaad7cca514157ea03cac916805a62f4ef.png",
    "https://cdn.faire.com/fastly/5447715e10a9096a1ebad45c5b28b45eebab542eadeb5dde045bcecc39f7e989.png",
    "https://cdn.faire.com/fastly/682f94596b8ff520a251bc933dd544f7bc19cbe035901bb2ee2d4a72579ad91a.png",
    "https://cdn.faire.com/fastly/ae2497ee936ab82007c27adb83bdb5b133b73f17d429eb35613c09552a4e989b.png",
    "https://cdn.faire.com/fastly/6d08994d9b4b2c01b8e6ae0b27bdf077ce48ea107ce7273283d3a10d1274e31e.png",
    "https://cdn.faire.com/fastly/4fd78102663ed5b7a8383cb0af1fec394782df47aed6ecc1b644e4aa046d3bbf.png",
    "https://cdn.faire.com/fastly/3ed58ab988095b7c7224ee9cc6370ec6a766feff4a9faf65d9cd60651b8d8826.jpeg",
    "https://cdn.faire.com/fastly/405c0ed63ce6c99119d4c62c7630b1781fba6197827c1a12d1991e15e03b5fbd.png",
    "https://cdn.faire.com/fastly/5e255882294705ca83b0901c24d94ddd70ade174bb94bab418e64df5b8e913b0.png",
    "https://cdn.faire.com/fastly/6770bd72b0f08917ee039e698b373e7f444ca638ea8fdd4fc9817705f8eb8f41.png",
    "https://cdn.faire.com/fastly/08eff2dbad198c03b5a970475fda5cd35f38201dd8f7ddb8f6af492d4a354609.png",
    "https://cdn.faire.com/fastly/cbaddb10f0435b16503f7f0588f8bdcc8950f0099308560a1a5f687652b7611d.png",
    "https://cdn.faire.com/fastly/504dca3edf166d0ce08e2692494724f69734956a8beb5ead1453bab255dcd6d6.png",
    "https://cdn.faire.com/fastly/d8807e8651c21e62df3da68df164f1ffd17d6676895f164ef6c5ed8943b4e1a5.png",
    "https://cdn.faire.com/fastly/3c0b5752fa839e84b782fa10db3efbe54aa7ae11edfeecc2c435539c8e14ec6c.png",
    "https://cdn.faire.com/fastly/cebc3c451fb3cf3c9f1a3c4f26d35049935a4433112f750b74f00d58dfc96965.png",
    "https://cdn.faire.com/fastly/52d9dc14f42c83bc133b790c1a9d241d7b486acb5c166b2a9b43d46282d814ce.jpeg",
    "https://cdn.faire.com/fastly/66b85c64a35d239c774181daa4151c04ef95cd58302ad1f2aa9793553243a9e8.jpeg",
    "https://cdn.faire.com/fastly/498889a34f0ddd04754d318cb0bab886462216dcb5775265d4db1a7c9fc4fe0d.png",
    "https://cdn.faire.com/fastly/1b6846e5f2cd4cfbec8ea5635a58f6eaa2daf19737aefa7a77573cc6b2283147.png",
  ],
  priceDollars: 13.85,
  description:
    "-SAME GREAT SHOWER STEAMERS ... NEW PACKAGING THAT IS HUMIDITY/TEMP SAFE AND PROLONGS SHELF-LIFE\n\nOur shower steamers are handmade in Hillsboro, Missouri and our small family-owned business has been specializing in shower steamers since 2018. We have 144,000+ sales and 29,000+ reviews on Etsy.  \nThis listing is for a single shower steamer of your choice! \nEach shower steamer is sealed in a pouch with instructions printed on the back. \nSize: 1.1 oz steamer (intended for 1 shower) about 2 inches in diameter and 1/2 in thick \n\nOur shower steamers are strongly scented with natural essential oils and or fragrances. \nSEE PICTURES FOR SCENT DESCRIPTIONS\n\nIf you choose the option for variety of random 10 - you will get a random selection of shower steamers. ",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:05.415Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
